import React from "react";
import { useAppState } from "@state/state";
import clsx from "clsx";
import { Icon, Text, AuthButton } from "@ui";
import { useRegisterCTAData } from "@staticQueries";

const RegisterCTA = () => {
  const [{ user, search }] = useAppState();
  const { view } = search;
  const { registerPrompt, registerCtaText } = useRegisterCTAData();

  if (user.loggedIn) {
    return null;
  }

  return (
    <div
      className={clsx({
        "w-full my-4": view === "cards",
        "relative md:pl-6 md:w-1/3": view === "list",
      })}
    >
      <div
        className={clsx({
          "bg-white shadow-card": true,
          "flex items-center rounded-full p-4": view === "cards",
          "text-center sticky top-6 my-3 p-6 lg:px-12 lg:py-8": view === "list",
        })}
      >
        <Icon
          className={clsx("text-red-dig p-1", {
            "w-10 h-10 mr-4": view === "cards",
            "w-16 h-16 mb-4": view === "list",
          })}
          name="DIG"
        />
        <Text
          className={clsx({
            "font-sans font-bold": true,
            "flex-1 pr-4": view === "cards",
            "mb-4": view === "list",
          })}
          preset="p"
        >
          {registerPrompt}
        </Text>
        <AuthButton
          preset="blue"
          text={registerCtaText}
          modalName="signInModal"
        />
      </div>
    </div>
  );
};

export default RegisterCTA;
